import {
  ASSIGN_LICENSE_REQUEST,
  ASSIGN_LICENSE_SUCCESS,
  ASSIGN_LICENSE_FAILURE,
  UNASSIGN_LICENSE_REQUEST,
  UNASSIGN_LICENSE_SUCCESS,
  UNASSIGN_LICENSE_FAILURE,
  LICENSE_REQUEST,
  LICENSE_SUCCESS,
  LICENSE_FAILURE,
} from './types';

const initialState = {
  licenseLoadingId: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LICENSE_REQUEST:
      return { ...state, licenseLoadingId: action.id };
    case LICENSE_SUCCESS:
      return { ...state, licenseLoadingId: null };
    case LICENSE_FAILURE:
      return { ...state, licenseLoadingId: null };
    case ASSIGN_LICENSE_REQUEST:
    case ASSIGN_LICENSE_SUCCESS:
    case ASSIGN_LICENSE_FAILURE:
    case UNASSIGN_LICENSE_REQUEST:
    case UNASSIGN_LICENSE_SUCCESS:
    case UNASSIGN_LICENSE_FAILURE:
      return state;
    default:
      return state;
  }
}
